<!--
/*******************************************************************************
*@ 컴포넌트명   : ApprovalCertification.vue
*@ 컴포넌트설명 : 결재상신 할 때 결재선 화면, 결재선 미지정 사용자 안내 화면
*@ 사용전문     : RBF0409X40 - 결재선관리목록조회
*@             : RCA040DB40 - 기업업무코드정보가져오기
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************

********************************************************************************/
-->
<template>
  <!-- 결재업무상신 -->
  <!-- 결재선 사용여부일 경우만 화면 표시 -->
  <article>
    <!-- 결재선이 설정된 사용자 -->
    <template v-if="approvalLineInfo.aprvalSngleYn == '결재선' && page != 'step1' ">
      <table-box css-type="type4">
        <template #content>
          <dt>{{/*단계*/$t("PCOP-01-01-01-02")}}</dt>
          <dd>
            <span>{{/*결재자*/$t("MCOM-0000075")}}</span>
          </dd>
          <template v-for="(list, i) of approvalLineInfo.list">
            <dt :key="`dt${i}`">{{i+1}}</dt>
            <dd :key="`dd${i}`">
              <span>
                {{list.aprvalWWWBnkgLginNM}}
                <!-- 결재선 본사사용자 구분 출력 -->
                <template v-if="list.hoYn == 'Y'">{{/*한국본사*/$t("MCOM-0000013")}}</template>
              </span>
            </dd>
          </template>
        </template>
      </table-box>
      <template v-if="approvalLineInfo.aprvalMemoAplyYn == '1'">
        <!-- 현재업무의 결재메모적용 여부에 따른 메모 표시 -->
        <div class="cont-tit">
          <h6>{{/*결재 상신 메모*/$t("MCOM-0000014")}}</h6>
        </div>
        <div class="form-textarea">
          <textarea class="form-control" v-model="memo"></textarea>
        </div>
      </template>
    </template>
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";
//import EventBus from "@/event-bus.js";
import { aprvalParam } from "@/mixins/approval";

export default {
  mixins: [aprvalParam],
  props: {
    //기업업무코드
    corpBzwkCd: {
      type: String,
      required: true,
    },
    page: {
      type: String,
    },
  },
  created() {
    if (this.approvalLineInfo.aprvalSngleYn == "") {
      //결재선관리목록조회_본사결재선대응
      this.RBF0409X40Call();
    } else if (this.approvalLineInfo.aprvalSngleYn == "미등록") {
      this.$router.push({ name: "errorPage", params: { type: this.$config.ERROR_NOT_APPROVAL_LINE } });
    } else {
      //기업업무정보 조회
      this.RCA040DB40Call();
    }
  },
  data() {
    return {
      aprvalList: {},
      memo: "",
    };
  },
  computed: {
    ...mapFields("admin", ["approvalLineInfo"]),
    ...mapFields(["sessionInfo"]),
  },
  methods: {
    /**
     * 결재선관리목록조회_본사결재선대응
     */
    RBF0409X40Call() {
      let param = {
        procTp: "6", //1 : 등록, 2 : 수정, 3 : 삭제, 4 : 조회, 5 : 목록다건조회, 6 : 목록단건조회
        regiWWWBnkgLginID: this.regiWwwBnkgLginId, //등록인터넷뱅킹로그인ID
        corpBzwkAprvalCd: "100000", //
        mainWWWBnkgLginID: this.mainWwwBnkgLginId, //주인터넷뱅킹로그인ID
        sessionYn: "Y",
      };
      this.$post("/customer/aprv/AprvalLineInfoInqury", param, this.RBF0409X40Suc);
    },

    RBF0409X40Suc(res) {
      const data = res.outItem;
      let array = [];
      for (let i = 1; i < 5; i++) {
        array.push({
          aprvalWWWBnkgLginID: data.gridRowCnt > 0 ? data.listGrid[0][`aprvalWWWBnkgLginID${i}`] : "",
          aprvalWWWBnkgLginNM: data.gridRowCnt > 0 ? data.listGrid[0][`aprvalWWWBnkgLginNM${i}`] : "",
          hoYn: data.gridRowCnt > 0 ? data.listGrid[0][`hoYn${i}`] : "",
        });
      }
      let aprvalStgeDstcd = "미등록";
      if (data.listGrid[0].aprvalRegYn == "1") {
        aprvalStgeDstcd = data.listGrid[0].aprvalStgeDstcd == "9" ? "단독결재" : "결재선";
      }
      this.approvalLineInfo = {
        aprvalSngleYn: aprvalStgeDstcd,
        list: array,
      };

      //기업업무정보 조회
      this.RCA040DB40Call();
    },

    /**
     * 기업업무정보 조회
     */
    RCA040DB40Call() {
      if (this.approvalLineInfo.aprvalSngleYn != "미등록") {
        if (this.approvalLineInfo.corpBzwkCd != this.corpBzwkCd) {
          this.$post("/customer/common/AprvalBzwkInfoInq", { corpBzwkCd: this.corpBzwkCd }, this.RCA040DB40Suc);
        }
      } else {
        this.$router.push({ name: "errorPage", params: { type: this.$config.ERROR_NOT_APPROVAL_LINE } });
      }
    },
    RCA040DB40Suc(res) {
      const data = res.outItem;
      if (!this._.isEmpty(data.corpBzwkCd)) {
        this.$set(this.approvalLineInfo, "corpBzwkCd", data.corpBzwkCd);
        this.$set(this.approvalLineInfo, "aprvalMemoAplyYn", data.aprvalMemoAplyYn);
        this.$set(this.approvalLineInfo, "aprvalUseYn", true);
        this.$set(this.approvalLineInfo, "corpBzwkCd", data.corpBzwkCd);
      }
    },
  },
  beforeDestroy() {
    //EventBus.$off("approvalCertification");
  },
};
</script>
